import { ReactNode, createContext, useContext } from "react";

export type iSource = "booking" | "chat" | "mcp";

const SourceContext = createContext<iSource>("booking");

export const SourceProvider = ({ source, children }: { source: iSource; children: ReactNode }) => (
  <SourceContext.Provider value={source}>{children}</SourceContext.Provider>
);

export const useSource = () => useContext(SourceContext);

export const bySource = <T,>(source: iSource, values: Record<iSource, T>): T => values[source];
